import { ReactElement } from 'react'

import { TFrameType } from '../services/client'
import { Frame1 } from './Frame1'
import { Frame2 } from './Frame2'
import { Frame3 } from './Frame3'
import { Frame4 } from './Frame4'
import { Frame5 } from './Frame5'
import { Frame6 } from './Frame6'
import { Frame7 } from './Frame7'
import { Frame8 } from './Frame8'
import { Frame9 } from './Frame9'
import { Frame10 } from './Frame10'
import { Frame11 } from './Frame11'
import { Frame12 } from './Frame12'
import { Frame13 } from './Frame13'
import { Frame14 } from './Frame14'
import { Frame15 } from './Frame15'
import { Frame16 } from './Frame16'
import { Frame17 } from './Frame17'
import { Frame18 } from './Frame18'
import { Frame19 } from './Frame19'
import { Frame20 } from './Frame20'
import { Frame21 } from './Frame21'
import { Frame22 } from './Frame22'
import { Frame23 } from './Frame23'
import { Frame24 } from './Frame24'
import { Frame25 } from './Frame25'
import { Frame26 } from './Frame26'
import { Frame27 } from './Frame27'
import { Frame28 } from './Frame28'
import { Frame29 } from './Frame29'
import { Frame30 } from './Frame30'
import { Frame31 } from './Frame31'
import { CURSIVE_FRAME_FONT, TFrameFont } from './qrFramesConstants'
import { TQrFrameProps } from './qrFrameTypes'

export type TFrame = {
	value: TFrameType
	Frame: (props: TQrFrameProps) => ReactElement
	darkDefaultTextColor?: boolean
	noFrameColor?: boolean
	noFrameBackground?: boolean
	incompatibleWithTransparentQrBackground?: boolean
	customMaxWidth?: number
	customFontFamily?: TFrameFont
	customMaxFontSize?: number
}

export const FRAME_TYPE_OPTION_LIST: TFrame[] = [
	{
		value: '1',
		Frame: Frame1,
		darkDefaultTextColor: true,
		noFrameColor: true,
	},
	{
		value: '2',
		Frame: Frame2,
		darkDefaultTextColor: true,
	},
	{
		value: '3',
		Frame: Frame3,
	},
	{
		value: '4',
		Frame: Frame4,
		darkDefaultTextColor: true,
	},
	{
		value: '5',
		Frame: Frame5,
	},
	{
		value: '6',
		Frame: Frame6,
		customMaxWidth: 40,
	},
	{
		value: '7',
		Frame: Frame7,
	},
	{
		value: '8',
		Frame: Frame8,
		noFrameBackground: true,
		incompatibleWithTransparentQrBackground: true,
	},
	{
		value: '9',
		Frame: Frame9,
		darkDefaultTextColor: true,
	},
	{
		value: '10',
		Frame: Frame10,
	},
	{
		value: '11',
		Frame: Frame11,
	},
	{
		value: '12',
		Frame: Frame12,
		customMaxWidth: 40,
	},
	{
		value: '13',
		Frame: Frame13,
		darkDefaultTextColor: true,
		noFrameColor: true,
		customFontFamily: CURSIVE_FRAME_FONT,
		customMaxFontSize: 20,
	},
	{
		value: '14',
		Frame: Frame14,
		customMaxWidth: 40,
	},
	{
		value: '15',
		Frame: Frame15,
		darkDefaultTextColor: true,
		customMaxWidth: 44,
		customMaxFontSize: 8,
	},
	{
		value: '16',
		Frame: Frame16,
		darkDefaultTextColor: true,
		customMaxWidth: 48,
		noFrameColor: true,
		customFontFamily: CURSIVE_FRAME_FONT,
		customMaxFontSize: 20,
	},
	{
		value: '17',
		Frame: Frame17,
		darkDefaultTextColor: true,
		customMaxWidth: 36,
		customMaxFontSize: 8,
	},
	{
		value: '18',
		Frame: Frame18,
		customMaxWidth: 50,
	},
	{
		value: '19',
		Frame: Frame19,
		customMaxWidth: 42,
		customMaxFontSize: 7,
	},
	{
		value: '20',
		Frame: Frame20,
		customMaxWidth: 40,
		customMaxFontSize: 7,
	},
	{
		value: '21',
		Frame: Frame21,
		darkDefaultTextColor: true,
		customMaxWidth: 38,
		customMaxFontSize: 8,
	},
	{
		value: '22',
		Frame: Frame22,
		customMaxWidth: 26,
		customMaxFontSize: 6,
	},
	{
		value: '23',
		Frame: Frame23,
		darkDefaultTextColor: true,
		customMaxWidth: 41,
		customMaxFontSize: 8,
	},
	{
		value: '24',
		Frame: Frame24,
		customMaxWidth: 38,
		customMaxFontSize: 7,
		incompatibleWithTransparentQrBackground: true,
	},
	{
		value: '25',
		Frame: Frame25,
		customMaxWidth: 48,
		customMaxFontSize: 8,
	},
	{
		value: '26',
		Frame: Frame26,
		customMaxWidth: 38,
		customMaxFontSize: 8,
	},
	{
		value: '27',
		Frame: Frame27,
		customMaxWidth: 39,
		customMaxFontSize: 7,
		incompatibleWithTransparentQrBackground: true,
	},
	{
		value: '28',
		Frame: Frame28,
		customMaxWidth: 33,
		customMaxFontSize: 7,
	},
	{
		value: '29',
		Frame: Frame29,
		customMaxWidth: 32,
		customMaxFontSize: 6,
	},
	{
		value: '30',
		Frame: Frame30,
		darkDefaultTextColor: true,
		customMaxWidth: 50,
		customMaxFontSize: 8,
	},
	{
		value: '31',
		Frame: Frame31,
		customMaxWidth: 33,
		customMaxFontSize: 8,
	},
]
